import React, { useState } from 'react';
import css from './SectionOfferingsForm.module.css';
import { Field } from 'react-final-form';
import { required } from '../../../util/validators';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
const DateNeededInputField = ({ fieldName, label }) => {
  const [focused, setFocused] = useState(false);
  const handleDateChange = (input, date) => {
    // Convert moment to JS Date or ISO string depending on your form needs
    input.onChange(date ? date.toDate() : null); // or date.format('YYYY-MM-DD')
  };
  return (
    <Field name={fieldName} validate={required('This field is required')}>
      {({ input, meta }) => (
        <div className={css.fieldGroup}>
          <label htmlFor={fieldName}>{label}</label>
          <SingleDatePicker
            date={input.value ? moment(input.value) : null}
            onDateChange={date => handleDateChange(input, date)}
            focused={focused}
            onFocusChange={({ focused: isFocused }) => setFocused(isFocused)}
            id={fieldName}
            placeholder={'MM/DD/YYYY'}
            isOutsideRange={day => day.isBefore(moment(), 'day')}
            displayFormat="MM/DD/YYYY"
            showClearDate
            noBorder
            readOnly={false}
            numberOfMonths={1}
          />
          {meta.error && meta.touched && <p className={css.error}>{meta.error}</p>}
        </div>
      )}
    </Field>
  );
};

export default DateNeededInputField;
